import {
  LOAD_CONTRACT_ACTIONS,
  CLEAR_CONTRACT_ACTIONS,
  SAVE_CONTRACT_ACTIONS_OPTIONS
} from '../actions/contractActionsActions';

const initialState = {
  options: { limit: +process.env.REACT_APP_TABLE_SIZE, page: 0 },
  items: [],
  count: 0,
  summary: {
    totalEvents: 0,
    altaCount: 0,
    altaAmount: 0,
    capitalCount: 0,
    capitalAmount: 0,
    terminationCount: 0,
    terminationAnticipadaCount: 0,
    terminationAnticipadaAmount: 0,
    cesionCount: 0
  }
};

const contractActionsReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOAD_CONTRACT_ACTIONS.success: {
      return {
        ...state,
        items: action.items,
        count: action.count,
        summary: action.summary
      };
    }
    case LOAD_CONTRACT_ACTIONS.failure: {
      return {
        ...state,
        summary: initialState.summary
      };
    }
    case SAVE_CONTRACT_ACTIONS_OPTIONS: {
      return {
        ...state,
        options: { ...state.options, ...action.options }
      };
    }
    case CLEAR_CONTRACT_ACTIONS: {
      return initialState;
    }
    default: {
      return state;
    }
  }
};

export default contractActionsReducer;
